/**
 * Page constructor
 * @constructor app.editor.board.Page
 */
 fx.ns("shared.stage", class Page extends shared.stage.BookArea {
    
	constructor(page, model, parentContainer, side)
	{
		super(page, model, parentContainer, side);
	}

	get page()
	{
		return this.data;
	}

	onReady() 
	{
		super.onReady();

		if (fx.browser.isDesktop)
		{
			this.on("mouseover", this.onMouseOver);
			this.on("mouseout", this.onMouseOut);
		}
	}

	create()
	{
		super.create();
	}

	refresh()
	{
		super.refresh();
		this.onDisplayUpdated();
	}


	load()
	{
		if (this.loaded)
			return;
		
		super.load();
	}


	unload()
	{
		if (!this.loaded)
	  		return;
        
        super.unload();	
	}
	
	onMouseOver(e)
	{
		if (this.model.zoom.value < 100 && this.loaded)
		{
			this.showActions(true);
            this.text.hide();
		}
	}

	onMouseOut(e)
	{
		if (this.model.zoom.value < 100 && this.loaded)
		{
			this.showActions(false);
			this.text.show();
		}
	}

	enableActions(val)
	{
		super.enableActions(val);

		if (!this.loaded) return;

		if (!this._actionsEnabled)
			this.showActions(false);
	}

	showActions(val)
	{
		if (!this.loaded) return;

		if (val && this._actionsEnabled)
			this._pagesButtonContainer.show();
		else
		    this._pagesButtonContainer.hide();
	}

    dragging(val)
    {
       this.toggleClass("dragging")
       this.dragActive = val;
        
    }

    // used for dragging pages
	/*activeOver(direction)
	{
		if (!this.loaded) return;

		if (this._activeDirection == direction)
			return;

		this.removeClass(this._activeDirection);

		this._activeDirection = direction;

		this.addClass(this._activeDirection);
	}*/

});